  
  import firebase from "firebase";
  
  // Your web app's Firebase configuration
  const firebaseConfig = {
    apiKey: "AIzaSyDtdbodsma1R3vYg-lEAeJMyBn0oQ2Tgxk",
    authDomain: "devaxel-site.firebaseapp.com",
    databaseURL: "https://devaxel-site.firebaseio.com",
    projectId: "devaxel-site",
    storageBucket: "devaxel-site.appspot.com",
    messagingSenderId: "558637807281",
    appId: "1:558637807281:web:40f0303c0b7764b0b15490"
  };

  console.log("firebase.apps", firebase.apps);

  // Initialize Firebase
  if(firebase.apps.length === 0){ //TODO: why is this needed???
    firebase.initializeApp(firebaseConfig); 
  }
  const database = firebase.database();
 
//    database.ref("settings").set({
//      name: "Funky Monk"
//    });

  //  database.ref("settings").on("child_changed", (snapshot) => { 
  //    console.log("setting changed: "+snapshot.key+" -> "+ snapshot.val())
  //  })

   firebase.auth().signInAnonymously()
  .then(() => {
    console.log("signed in on anonymously");
  })
  .catch((error) => {
    console.log("error "+error.code+": "+error.message);
  })

  firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      var uid = user.uid;
      console.log("uid: "+uid);
    } else {
      // User is signed out
      // ...
    }
  });

  export { firebase, database as default }